// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  --login-blue: #1e75ff;
  --login-blue-deep: #0a3ea2;
  --login-ink: #07090f;
  --login-card: rgba(14, 17, 28, 0.72);
  --login-field: #0c1220;
  color-scheme: dark;
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: auto;
  background:
    radial-gradient(1200px 600px at 12% 10%, rgba(30, 117, 255, 0.22), transparent 55%),
    radial-gradient(900px 500px at 90% 90%, rgba(10, 62, 162, 0.35), transparent 50%),
    linear-gradient(160deg, #05060a 0%, #0b1020 52%, #07090f 100%);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #eef3ff;
}

.login-page,
.login-page * {
  box-sizing: border-box;
}

.login-page::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: radial-gradient(circle at center, black 18%, transparent 78%);
  pointer-events: none;
}

.login-shell {
  position: relative;
  width: min(980px, 100%);
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  min-height: 560px;
  border-radius: 28px;
  overflow: hidden;
  border: 1px solid rgba(168, 199, 255, 0.16);
  background: var(--login-card);
  box-shadow:
    0 30px 80px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(18px);
}

.login-brand {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 44px;
  background:
    linear-gradient(180deg, rgba(30, 117, 255, 0.16), rgba(7, 9, 15, 0.2) 55%),
    linear-gradient(135deg, rgba(10, 62, 162, 0.35), transparent);
  border-right: 1px solid rgba(168, 199, 255, 0.12);
}

.login-brand img {
  width: min(280px, 100%);
  height: auto;
  display: block;
  filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.35));
}

.login-kicker {
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #8eb6ff;
}

.login-brand h1 {
  margin: 0;
  font-size: clamp(1.7rem, 2.4vw, 2.35rem);
  line-height: 1.15;
  letter-spacing: -0.03em;
  font-weight: 720;
  color: #fff;
}

.login-lead {
  margin: 16px 0 0;
  max-width: 34ch;
  font-size: 0.98rem;
  line-height: 1.55;
  color: rgba(226, 234, 255, 0.72);
}

.login-meta {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  margin-top: 36px;
  color: rgba(226, 234, 255, 0.55);
  font-size: 12px;
  letter-spacing: 0.04em;
}

.login-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 48px 42px;
}

.login-panel h2 {
  margin: 0;
  font-size: 1.55rem;
  letter-spacing: -0.03em;
  color: #fff;
}

.login-panel p {
  margin: 8px 0 28px;
  color: rgba(226, 234, 255, 0.62);
  font-size: 0.92rem;
}

.login-form {
  display: grid;
  gap: 16px;
  width: 100%;
  min-width: 0;
}

.login-field {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.login-field label {
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9bb6e8;
}

.login-input-wrap {
  position: relative;
  width: 100%;
  min-width: 0;
}

.login-field input {
  width: 100%;
  max-width: 100%;
  height: 52px;
  border: 1px solid #d7e2f5;
  border-radius: 14px;
  background: #fff;
  background-color: #fff;
  color: #12203a;
  -webkit-text-fill-color: #12203a;
  caret-color: #12203a;
  padding: 0 46px 0 16px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
}

.login-field input:focus {
  border-color: var(--login-blue);
  box-shadow: 0 0 0 4px rgba(30, 117, 255, 0.18);
  background: #fff;
  background-color: #fff;
}

.login-field input::placeholder {
  color: #8a97b0;
  -webkit-text-fill-color: #8a97b0;
}

.login-field input:-webkit-autofill,
.login-field input:-webkit-autofill:hover,
.login-field input:-webkit-autofill:focus,
.login-field input:-webkit-autofill:active {
  -webkit-text-fill-color: #12203a !important;
  caret-color: #12203a;
  border: 1px solid #d7e2f5;
  -webkit-transition: background-color 99999s ease-out;
  transition: background-color 99999s ease-out;
  box-shadow: 0 0 0 1000px #fff inset !important;
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
}

.login-field input:-webkit-autofill:focus {
  border-color: var(--login-blue);
  box-shadow:
    0 0 0 1000px #fff inset,
    0 0 0 4px rgba(30, 117, 255, 0.18) !important;
  -webkit-box-shadow:
    0 0 0 1000px #fff inset,
    0 0 0 4px rgba(30, 117, 255, 0.18) !important;
}

.login-toggle {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #5b6b88;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.login-toggle:hover {
  background: rgba(30, 117, 255, 0.12);
  color: var(--login-blue-deep);
}

.login-error {
  margin: 0;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.28);
  background: rgba(127, 29, 29, 0.28);
  color: #fecaca;
  font-size: 13px;
}

.login-submit {
  margin-top: 6px;
  height: 52px;
  border: 0;
  border-radius: 14px;
  cursor: pointer;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  background: linear-gradient(180deg, #3b8bff 0%, var(--login-blue) 48%, var(--login-blue-deep) 100%);
  box-shadow: 0 12px 24px rgba(10, 62, 162, 0.35);
  transition: transform 0.15s ease, filter 0.15s ease;
}

.login-submit:hover:not(:disabled) {
  filter: brightness(1.06);
  transform: translateY(-1px);
}

.login-submit:disabled {
  opacity: 0.7;
  cursor: wait;
}

.login-foot {
  margin: 22px 0 0;
  font-size: 12px;
  color: rgba(196, 210, 240, 0.42);
}

@media (max-width: 860px) {
  .login-page {
    padding: 12px;
    align-items: stretch;
  }

  .login-shell {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .login-brand {
    padding: 28px 28px 18px;
    border-right: 0;
    border-bottom: 1px solid rgba(168, 199, 255, 0.12);
  }

  .login-brand h1,
  .login-lead,
  .login-meta {
    display: none;
  }

  .login-brand img {
    width: min(220px, 70%);
    margin: 0 auto;
  }

  .login-panel {
    padding: 28px 24px 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd;;;kEAGgE;EAChE,8FAA8F;EAC9F,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;2EAEyE;EACzE,0BAA0B;EAC1B,yEAAyE;EACzE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,6BAA6B;EAC7B;;2CAEyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB;;iEAE+D;EAC/D,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,wDAAwD;EACxD,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;;;;EAIE,2CAA2C;EAC3C,oBAAoB;EACpB,yBAAyB;EACzB,oDAA4C;EAA5C,4CAA4C;EAC5C,8CAA8C;EAC9C,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B;;iDAE+C;EAC/C;;iDAE+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mGAAmG;EACnG,+CAA+C;EAC/C,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,kDAAkD;EACpD;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".login-page {\r\n  --login-blue: #1e75ff;\r\n  --login-blue-deep: #0a3ea2;\r\n  --login-ink: #07090f;\r\n  --login-card: rgba(14, 17, 28, 0.72);\r\n  --login-field: #0c1220;\r\n  color-scheme: dark;\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 40;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  overflow: auto;\r\n  background:\r\n    radial-gradient(1200px 600px at 12% 10%, rgba(30, 117, 255, 0.22), transparent 55%),\r\n    radial-gradient(900px 500px at 90% 90%, rgba(10, 62, 162, 0.35), transparent 50%),\r\n    linear-gradient(160deg, #05060a 0%, #0b1020 52%, #07090f 100%);\r\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\r\n  color: #eef3ff;\r\n}\r\n\r\n.login-page,\r\n.login-page * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.login-page::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(255, 255, 255, 0.035) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px);\r\n  background-size: 56px 56px;\r\n  mask-image: radial-gradient(circle at center, black 18%, transparent 78%);\r\n  pointer-events: none;\r\n}\r\n\r\n.login-shell {\r\n  position: relative;\r\n  width: min(980px, 100%);\r\n  display: grid;\r\n  grid-template-columns: 1.05fr 0.95fr;\r\n  min-height: 560px;\r\n  border-radius: 28px;\r\n  overflow: hidden;\r\n  border: 1px solid rgba(168, 199, 255, 0.16);\r\n  background: var(--login-card);\r\n  box-shadow:\r\n    0 30px 80px rgba(0, 0, 0, 0.45),\r\n    inset 0 1px 0 rgba(255, 255, 255, 0.06);\r\n  backdrop-filter: blur(18px);\r\n}\r\n\r\n.login-brand {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  padding: 48px 44px;\r\n  background:\r\n    linear-gradient(180deg, rgba(30, 117, 255, 0.16), rgba(7, 9, 15, 0.2) 55%),\r\n    linear-gradient(135deg, rgba(10, 62, 162, 0.35), transparent);\r\n  border-right: 1px solid rgba(168, 199, 255, 0.12);\r\n}\r\n\r\n.login-brand img {\r\n  width: min(280px, 100%);\r\n  height: auto;\r\n  display: block;\r\n  filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.35));\r\n}\r\n\r\n.login-kicker {\r\n  margin: 0 0 10px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.22em;\r\n  text-transform: uppercase;\r\n  color: #8eb6ff;\r\n}\r\n\r\n.login-brand h1 {\r\n  margin: 0;\r\n  font-size: clamp(1.7rem, 2.4vw, 2.35rem);\r\n  line-height: 1.15;\r\n  letter-spacing: -0.03em;\r\n  font-weight: 720;\r\n  color: #fff;\r\n}\r\n\r\n.login-lead {\r\n  margin: 16px 0 0;\r\n  max-width: 34ch;\r\n  font-size: 0.98rem;\r\n  line-height: 1.55;\r\n  color: rgba(226, 234, 255, 0.72);\r\n}\r\n\r\n.login-meta {\r\n  display: flex;\r\n  gap: 18px;\r\n  flex-wrap: wrap;\r\n  margin-top: 36px;\r\n  color: rgba(226, 234, 255, 0.55);\r\n  font-size: 12px;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.login-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  min-width: 0;\r\n  padding: 48px 42px;\r\n}\r\n\r\n.login-panel h2 {\r\n  margin: 0;\r\n  font-size: 1.55rem;\r\n  letter-spacing: -0.03em;\r\n  color: #fff;\r\n}\r\n\r\n.login-panel p {\r\n  margin: 8px 0 28px;\r\n  color: rgba(226, 234, 255, 0.62);\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.login-form {\r\n  display: grid;\r\n  gap: 16px;\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.login-field {\r\n  display: grid;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.login-field label {\r\n  font-size: 12px;\r\n  font-weight: 650;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: #9bb6e8;\r\n}\r\n\r\n.login-input-wrap {\r\n  position: relative;\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.login-field input {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  height: 52px;\r\n  border: 1px solid #d7e2f5;\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  background-color: #fff;\r\n  color: #12203a;\r\n  -webkit-text-fill-color: #12203a;\r\n  caret-color: #12203a;\r\n  padding: 0 46px 0 16px;\r\n  font-size: 15px;\r\n  outline: none;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n  box-shadow: none;\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n}\r\n\r\n.login-field input:focus {\r\n  border-color: var(--login-blue);\r\n  box-shadow: 0 0 0 4px rgba(30, 117, 255, 0.18);\r\n  background: #fff;\r\n  background-color: #fff;\r\n}\r\n\r\n.login-field input::placeholder {\r\n  color: #8a97b0;\r\n  -webkit-text-fill-color: #8a97b0;\r\n}\r\n\r\n.login-field input:-webkit-autofill,\r\n.login-field input:-webkit-autofill:hover,\r\n.login-field input:-webkit-autofill:focus,\r\n.login-field input:-webkit-autofill:active {\r\n  -webkit-text-fill-color: #12203a !important;\r\n  caret-color: #12203a;\r\n  border: 1px solid #d7e2f5;\r\n  transition: background-color 99999s ease-out;\r\n  box-shadow: 0 0 0 1000px #fff inset !important;\r\n  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;\r\n}\r\n\r\n.login-field input:-webkit-autofill:focus {\r\n  border-color: var(--login-blue);\r\n  box-shadow:\r\n    0 0 0 1000px #fff inset,\r\n    0 0 0 4px rgba(30, 117, 255, 0.18) !important;\r\n  -webkit-box-shadow:\r\n    0 0 0 1000px #fff inset,\r\n    0 0 0 4px rgba(30, 117, 255, 0.18) !important;\r\n}\r\n\r\n.login-toggle {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 8px;\r\n  transform: translateY(-50%);\r\n  border: 0;\r\n  background: transparent;\r\n  color: #5b6b88;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.login-toggle:hover {\r\n  background: rgba(30, 117, 255, 0.12);\r\n  color: var(--login-blue-deep);\r\n}\r\n\r\n.login-error {\r\n  margin: 0;\r\n  padding: 10px 12px;\r\n  border-radius: 12px;\r\n  border: 1px solid rgba(239, 68, 68, 0.28);\r\n  background: rgba(127, 29, 29, 0.28);\r\n  color: #fecaca;\r\n  font-size: 13px;\r\n}\r\n\r\n.login-submit {\r\n  margin-top: 6px;\r\n  height: 52px;\r\n  border: 0;\r\n  border-radius: 14px;\r\n  cursor: pointer;\r\n  color: #fff;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n  background: linear-gradient(180deg, #3b8bff 0%, var(--login-blue) 48%, var(--login-blue-deep) 100%);\r\n  box-shadow: 0 12px 24px rgba(10, 62, 162, 0.35);\r\n  transition: transform 0.15s ease, filter 0.15s ease;\r\n}\r\n\r\n.login-submit:hover:not(:disabled) {\r\n  filter: brightness(1.06);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.login-submit:disabled {\r\n  opacity: 0.7;\r\n  cursor: wait;\r\n}\r\n\r\n.login-foot {\r\n  margin: 22px 0 0;\r\n  font-size: 12px;\r\n  color: rgba(196, 210, 240, 0.42);\r\n}\r\n\r\n@media (max-width: 860px) {\r\n  .login-page {\r\n    padding: 12px;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .login-shell {\r\n    grid-template-columns: 1fr;\r\n    min-height: auto;\r\n  }\r\n\r\n  .login-brand {\r\n    padding: 28px 28px 18px;\r\n    border-right: 0;\r\n    border-bottom: 1px solid rgba(168, 199, 255, 0.12);\r\n  }\r\n\r\n  .login-brand h1,\r\n  .login-lead,\r\n  .login-meta {\r\n    display: none;\r\n  }\r\n\r\n  .login-brand img {\r\n    width: min(220px, 70%);\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .login-panel {\r\n    padding: 28px 24px 32px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
